export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  transfer: 'Transferencia Bancaria',
  direct_debit: 'Giro Directo (Domiciliado)',
  credit_card: 'Tarjeta de Crédito de Cuenta',
  cash: 'Efectivo / Contado',
};

export const PAYMENT_TERMS_LABELS: Record<string, string> = {
  immediate: 'Pago Inmediato',
  '30_days': '30 Días Fecha Factura',
  '60_days': '60 Días Fecha Factura',
  '90_days': '90 Días Fecha Factura',
};

export const CLIENT_STATUS_OPTIONS = [
  { value: 'all', label: 'TODOS LOS ESTADOS' },
  { value: 'active', label: 'ACTIVO' },
  { value: 'inactive', label: 'INACTIVO' },
  { value: 'blocked', label: 'BLOQUEADO' },
];
